import React from "react";
import { useDispatch } from "react-redux";
import { setactiveItem } from "store/cards";
import { useLocation, useNavigate } from "react-router-dom";
import CommonItemTag from "./CommonItemTag";
import CommonItemInfo from "./CommonItemInfo";
import CommonItemFlag from "./CommonItemFlag";
import CommonItemExpired from "./CommonItemExpired";
import { useSoundPath } from "hooks/useSoundPath";
import useActiveItem from "hooks/useActiveItem";

const CommonItems = ({ items }) => {
  const { pathname } = useLocation();
  const { activeItem } = useActiveItem();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const playSound = useSoundPath();

  const openPack = (id) => {
    if (pathname === "/inventory/card-packs") {
      navigate(`/inventory/card-pack-open/${id}`);
    }
  };

  return (
    <ul
      className={`cards-list__block ${
        items.length | activeItem && "cards-list__block--min"
      }`}
    >
      {items.map((item) => (
        <li
          key={item.id}
          className={`cards-list__block-item ${
            activeItem === item ? "active" : ""
          } ${
            item.type.toLowerCase() === "event"
              ? item.is_valid_event === false
                ? "cards-list__block-item--expired"
                : ""
              : ""
          }`}
          onClick={() => {
            dispatch(setactiveItem(item));
            playSound("main");
          }}
          onDoubleClick={() => openPack(item.id)}
        >
          <CommonItemInfo
            image={item.image}
            type={item.type}
            name={item.name}
            props={item.properties}
          />
          <p className="cards-list__block-item-text">
            {item.type.toLowerCase() === "prize" ? "$" + item.name : item.name}
          </p>
          {pathname.includes("/marketplace") && item.tag === "For Sale" ? (
            <p className="cards-list__block-item-rarity">${item.cost} USD</p>
          ) : null}
          <CommonItemTag tag={item.tag} isMine={item.owned_by_self} />
          <CommonItemFlag
            isListed={item.is_listed}
            isMine={item.owned_by_self}
          />
          {item.type.toLowerCase() === 'event' && item.is_valid_event === false && (
            <CommonItemExpired />
          )}
        </li>
      ))}
    </ul>
  );
};

export default CommonItems;
